import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormValues, RequestPasswordResetFormStep, validation } from './RequestPasswordReset.meta';

declare const VIEW_DATA: {
  model: {
    Email: string | null;
    IsCompleted: boolean;
    ErrorMessage: string | null;
    BrandingLogoFileName: string;
    SelfRegistrationReferrerUrlId: string | null;
    OrganizationId: string | null;
    AdviserId: string | null;
  };
  csrfToken: string;
  assetsEndpoint: string;
  termsAndConditionsUrl: string;
};

export const useRequestPasswordReset = () => {
  const [step, setStep] = useState(RequestPasswordResetFormStep.Email);

  const [backendError, setBackendError] = useState<string | null>(null);

  const { register, formState, handleSubmit, watch } = useForm<FormValues>({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(validation),
  });

  const email = watch('email');

  const onSubmit = handleSubmit(async data => {
    const formData = new FormData();

    formData.append('Email', data.email);
    formData.append('__RequestVerificationToken', VIEW_DATA.csrfToken);

    try {
      const response = await fetch('/ResetPassword', {
        method: 'POST',
        body: formData,
        headers: { accept: 'application/json' },
      });

      if (response.ok) {
        const { success, errors } = await response.json();

        if (!success) {
          setBackendError(errors[0]);
        } else {
          setStep(RequestPasswordResetFormStep.LinkInstructions);
        }
      }
    } catch (err) {
      setBackendError('There was an issue completing your request. Please try again later.');
    }
  });

  return {
    onSubmit,
    email,
    register,
    formState,
    backendError,
    step,
    logoUrl: VIEW_DATA.model.BrandingLogoFileName,
    assetsEndpoint: VIEW_DATA.assetsEndpoint,
    termsAndConditionsUrl: VIEW_DATA.termsAndConditionsUrl,
  };
};
